import { HttpParams } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Config } from 'src/app/app-constant';
import { PdfDownloadService } from 'src/app/pdf-download-service.service';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { HttpService } from 'src/app/service/http/http.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { calculateFiscalYear, createChart, createChartELCM, formatDate, formatYearRanges} from 'src/app/shared/commen-function-file';

@Component({
  selector: 'app-elcm-dashboard',
  templateUrl: './elcm-dashboard.component.html',
  styleUrls: ['./elcm-dashboard.component.scss'],
})
export class ElcmDashboardComponent implements OnInit {
  @Input() num1: any;
  @Input() num2: any;
  @Output() sum = new EventEmitter<any>();

  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserCompanyID: any;
  subModuleButtonColor: any;
  loggedInCompanyFiscalyear: any;
  loggedInUserEmpCode: any
  selectedYear: any;
  pmsYears: any = [];
  loggedInUserId: any;
  fromYear: any;
  toYear: any;
  fromDate: any;
  monthNumber: any;
  fromDate1: any;
  selectedYearForFirstGraph: any;
  fromDate2: any;
  fromDate3: any;
  fromDate4: any;
  selectedYeargraph1: any;
  selectedYeargraph2: any;
  selectedYeargraph3: any;
  selectedYeargraph4: any;
  selectedYeargraph5: any;
  fromDate5: any;
  setupNotCompleted: boolean = false;
  confirmationProbationWhomSetup: any
  constructor(public sharedService: SharedService, private httpService: HttpService, private PdfDownload: PdfDownloadService, private config: Config, private encryptionService: EncryptionService,) { }

  ngOnInit() {
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.subModuleButtonColor = sessionStorage.getItem('subModuleButtonColor');
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    this.loggedInUserEmpCode = sessionStorage.getItem('empCode');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.confirmationProbationWhomSetup = this.httpService.confirmationProbationWhomSetup;
    this.setupNotCompleted = this.httpService.notcompletedElcmSetUp
    this.getpmsyearlist();

  }

 
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];
  
  //     // Process API response and filter past/current years
  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       var test = ele.split('_');
  //       let obj = {
  //         year: test[0] + '-' + test[1]
  //       };
  
  //       // Get current year
  //       const currentYear = new Date().getFullYear();
  
  //       // Ensure only past and current years are included
  //       var yearParts = obj.year.split('-');
  //       let fromYear = parseInt(yearParts[0]);
  //       let toYear = parseInt(yearParts[1]);
  
  //       // Add to pmsYears only if it's not a future year
  //       if (toYear <= currentYear) {
  //         this.pmsYears.push(obj);
  //       }
  //     });
  
  //     // Determine the current fiscal year based on company settings
  //     const today = new Date();
  //     const currentYear = today.getFullYear();
  //     const currentMonth = today.getMonth(); // 0 = Jan, 11 = Dec
  //     let fiscalStartYear: number, fiscalEndYear: number;
  //     let yearValue: string = ""; // Explicitly define yearValue as a string
  
  //     switch (this.loggedInCompanyFiscalyear) {
  //       case 'Jan_Dec':
  //         fiscalStartYear = currentYear;
  //         fiscalEndYear = currentYear;
  //         break;
  
  //       case 'Apr_Mar':
  //         if (currentMonth < 3) { // Jan, Feb, Mar
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       case 'July_Jun':
  //         if (currentMonth < 6) { // Jan to Jun
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       case 'Oct_Sep':
  //         if (currentMonth < 9) { // Jan to Sep
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       default:
  //         console.warn("Invalid Fiscal Year Format");
  //         return;
  //     }
  
  //     yearValue = `${fiscalStartYear}-${fiscalEndYear}`; // Ensure yearValue is a string
  
  //     // Iterate over the years and set the selected year for various fields
  //     this.pmsYears?.forEach((ele: any) => {
  //       if (ele?.year === yearValue) {
  //         this.selectedYear = ele?.year;
  //         this.selectedYeargraph1 = ele.year;
  //         this.selectedYeargraph2 = ele.year;
  //         this.selectedYeargraph3 = ele.year;
  //         this.selectedYeargraph4 = ele.year;
  //         this.selectedYeargraph5 = ele.year;
  
  //         let test = ele?.year?.split('-');
  //         this.fromYear = test[0];
  //         this.toYear = test[1];
  //       }
  //     });
  
  //     this.getMonths(this.fromYear, this.toYear);
  //   });
  // }
  
  // getpmsyearlist() {
  //   this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
  //     this.pmsYears = [];
  
  //     // Convert year ranges from API response into "YYYY-YYYY" format
  //     data?.data?.yearRanges?.forEach((ele: any) => {
  //       let yearParts = ele.split('_'); 
  //       let formattedYear = `${yearParts[0]}-${yearParts[1]}`;
  //       this.pmsYears.push({ year: formattedYear });
  //     });
  
  //     // Get the current date
  //     const today = new Date();
  //     const currentYear = today.getFullYear();
  //     const currentMonth = today.getMonth(); // 0 = Jan, 11 = Dec
  //     let fiscalStartYear, fiscalEndYear;
  
  //     // Manage according to the selected fiscal year format
  //     switch (this.loggedInCompanyFiscalyear) {
  //       case 'Jan_Dec':
  //         fiscalStartYear = currentYear;
  //         fiscalEndYear = currentYear;
  //         break;
  
  //       case 'Apr_Mar':
  //         if (currentMonth < 3) { // Jan, Feb, Mar
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       case 'July_Jun':
  //         if (currentMonth < 6) { // Jan to Jun
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       case 'Oct_Sep':
  //         if (currentMonth < 9) { // Jan to Sep
  //           fiscalStartYear = currentYear - 1;
  //           fiscalEndYear = currentYear;
  //         } else {
  //           fiscalStartYear = currentYear;
  //           fiscalEndYear = currentYear + 1;
  //         }
  //         break;
  
  //       default:
  //         console.warn("Invalid Fiscal Year Format");
  //         return;
  //     }
  
  //     const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
  //     // Find and set the correct year from the available list
  //     this.pmsYears.forEach((ele: any) => {
  //       if (ele?.year === yearValue) {
  //                 this.selectedYear = ele?.year;
  //                 this.selectedYeargraph1 = ele.year;
  //                 this.selectedYeargraph2 = ele.year;
  //                 this.selectedYeargraph3 = ele.year;
  //                 this.selectedYeargraph4 = ele.year;
  //                 this.selectedYeargraph5 = ele.year;
          
  //                 let test = ele?.year?.split('-');
  //                 this.fromYear = test[0];
  //                 this.toYear = test[1];
  //               }
  //             });
          
  //             this.getMonths(this.fromYear, this.toYear);
  //           });
  // }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.pmsYears = formatYearRanges(data?.data?.yearRanges);

      const { fiscalStartYear, fiscalEndYear } = calculateFiscalYear(this.loggedInCompanyFiscalyear);

      const yearValue = `${fiscalStartYear}-${fiscalEndYear}`;
  
      this.setSelectedYear(yearValue);
      this.getMonths(this.fromYear, this.toYear);
    });
  }
setSelectedYear(yearValue: string): void {
  const selectedYearObj = this.pmsYears.find((ele:any) => ele.year === yearValue);
  if (selectedYearObj) {
    this.selectedYear = this.selectedYeargraph1 = this.selectedYeargraph2 =
      this.selectedYeargraph3 = this.selectedYeargraph4 = this.selectedYeargraph5 = selectedYearObj.year;
    
    [this.fromYear, this.toYear] = selectedYearObj.year.split('-');
  }
}

  











  getMonthsByFiscalandReviewCycle: any = [];
  getMonthsList: any = []
  getMonths(fromYear: any, toYear: any) {
    // const request = {
    //   companyId: this.loggedInUserCompanyID,
    //   fromYear: fromYear,
    //   toYear: toYear
    // }
    // this.httpService.callPostService(this.config.getMonths, request).subscribe((data: any) => {

    //   this.getMonthsByFiscalandReviewCycle = data.data?.months;

    //   this.getMonthsByFiscalandReviewCycle = data.data?.months;
    //   console.log('Original months array:', this.getMonthsByFiscalandReviewCycle);
    //   type Month =
    //     | 'January'
    //     | 'February'
    //     | 'March'
    //     | 'April'
    //     | 'May'
    //     | 'June'
    //     | 'July'
    //     | 'August'
    //     | 'September'
    //     | 'October'
    //     | 'November'
    //     | 'December';

    //   // Create a typed mapping of month names to numbers.
    //   const monthNumbers: Record<Month, number> = {
    //     January: 1,
    //     February: 2,
    //     March: 3,
    //     April: 4,
    //     May: 5,
    //     June: 6,
    //     July: 7,
    //     August: 8,
    //     September: 9,
    //     October: 10,
    //     November: 11,
    //     December: 12,
    //   };

    //   // Assuming this.getMonthsByFiscalandReviewCycle is an array of strings:
    //   const monthRanges: string[] = this.getMonthsByFiscalandReviewCycle || [];

    //   // Process each range.
    //   const monthsWithNumbers = monthRanges.map((range: string) => {
    //     const [firstMonth] = range.split('-');

    //     // Check if the firstMonth is a valid key in our monthNumbers mapping.
    //     if (!(firstMonth in monthNumbers)) {
    //       throw new Error(`Unexpected month: ${firstMonth}`);
    //     }

    //     // Type assertion: firstMonth is a valid Month.
    //     const monthKey = firstMonth as Month;
    //     const key = `${firstMonth} monthinNo`;
    //     const monthNo = monthNumbers[monthKey];

    //     return {
    //       range: range,
    //       [key]: monthNo
    //     };
    //   });

    //   console.log(monthsWithNumbers);

    //   this.getMonthsList = monthsWithNumbers.map((ele: any) => {
    //     // Extract the month name from the range (before the hyphen)
    //     let monthName = ele.range.split('-')[0];

    //     // Find the corresponding month number dynamically
    //     let monthKey = `${monthName} monthinNo`;

    //     return {

    //       number: ele[monthKey], // Dynamically accessing the correct key
    //       name: ele.range
    //     }


    //   });
    //   console.log(this.getMonthsList);


    //   const today = new Date();
    //   this.monthNumber = today.getMonth() + 1; // getMonth() returns 0-11, so add 1
    //   this.fromDate = this.monthNumber
    //   this.fromDate1 = this.monthNumber
    //   this.fromDate2 = this.monthNumber
    //   this.fromDate3 = this.monthNumber
    //   this.fromDate4 = this.monthNumber
    //   this.fromDate5 = this.monthNumber
    //   this.getElCMCountData();
    //   setTimeout(() => {
    //     this.manageeveryTabCount();
    //   }, 400)
    //   this.getEmployee()
    //   this.getProbationList();
    //   // this.hodAndManagerGraph();
    //   this.getEmployeeList();
    //   this.switchelcmTypeGraph1('bar');
    //   this.switchelcmTypeGraph2('bar');
    //   this.switchElcmTypeGraph3('bar');
    //   this.switchElcmTypeGraph4('bar');
    //   this.switchelcmTypeGraphFiledHr('bar');



    // })

    type Month =
      | 'January' | 'February' | 'March' | 'April'
      | 'May' | 'June' | 'July' | 'August'
      | 'September' | 'October' | 'November' | 'December';

    const monthNumbers: Record<Month, number> = {
      January: 1, February: 2, March: 3, April: 4,
      May: 5, June: 6, July: 7, August: 8,
      September: 9, October: 10, November: 11, December: 12,
    };

    // Function to get months based on fiscal year
    const getMonthsByFiscalYear = (fiscalYear: string) => {
      switch (fiscalYear) {
        case 'Jan-Dec':
          return Object.keys(monthNumbers);
        case 'Apr-Mar':
          return ['April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March'];
        case 'July-Jun':
          return ['July', 'August', 'September', 'October', 'November', 'December', 'January', 'February', 'March', 'April', 'May', 'June'];
        case 'Oct-Sep':
          return ['October', 'November', 'December', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September'];
        default:
          throw new Error(`Unexpected fiscal year: ${fiscalYear}`);
      }
    };

    // Example: Fetching months for a selected fiscal year
    const selectedFiscalYear = 'Apr-Mar';
    const monthsList = getMonthsByFiscalYear(selectedFiscalYear);

    // Mapping to include month numbers
    const monthsWithNumbers = monthsList.map(month => ({
      name: month,
      number: monthNumbers[month as Month],
    }));
    this.getMonthsList = monthsWithNumbers;
    console.log('Mapped Months:', monthsWithNumbers);
    const today = new Date();
    this.monthNumber = today.getMonth() + 1; // getMonth() returns 0-11, so add 1
    this.fromDate = this.monthNumber
    this.fromDate1 = this.monthNumber
    this.fromDate2 = this.monthNumber
    this.fromDate3 = this.monthNumber
    this.fromDate4 = this.monthNumber
    this.fromDate5 = this.monthNumber
    this.getElCMCountData();
    setTimeout(() => {
      this.manageeveryTabCount();
    }, 400)
    this.getEmployee()
    this.getProbationList();
    // this.hodAndManagerGraph();
    this.getEmployeeList();
    this.switchelcmTypeGraph1('bar');
    this.switchelcmTypeGraph2('bar');
    this.switchElcmTypeGraph3('bar');
    this.switchElcmTypeGraph4('bar');
    this.switchelcmTypeGraphFiledHr('bar');
    this.forDepartmentDropDown();
    this.allDropDown();
  }
  employyeApplicationFromdata: any;
  probationCount: any;
  getElCMCountData() {
    this.httpService.callGetService(`${this.config.elcmgraphCount}?companyId=${this.loggedInUserCompanyID}&month=${this.monthNumber}&year=${this.selectedYear}`)
      .subscribe((response: any) => {
        this.employyeApplicationFromdata = response.data;
        console.log(this.employyeApplicationFromdata);
        this.manageeveryTabCount();

      })
    this.httpService.callGetService(`${this.config.probationCount}?companyId=${this.loggedInUserCompanyID}&month=${this.monthNumber}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}&department=Finance`)
      .subscribe((response: any) => {
        this.probationCount = response.data;
        console.log(this.probationCount);
        this.manageeveryTabCount();
      })
  }

  onClickYtdYear(event: any, valueName: any, graphNo: any) {
    console.log(event);
    
    if (valueName == 'Year') {
      if (graphNo == 'graph1') {
        this.selectedYeargraph1 = event.value;
        console.log(this.selectedYear);

        this.firstGraph(this.isElcmTypeIcon);
      }
      if (graphNo == 'graph2') {
        // this.selectedYear = event.value;
        this.selectedYeargraph2 = event.value;
        console.log(this.selectedYear);

        this.hrField2Graph(this.isElcmTypeIconFieldHr);
      }
      if (graphNo == 'graph3') {
        // this.selectedYear = event.value;
        console.log(this.selectedYear);
        this.selectedYeargraph3 = event.value;
        this.secondGraph(this.isElcmTypeIcon2);
      }
      if (graphNo == 'graph4') {
        // this.selectedYear = event.value;
        console.log(this.selectedYear);
        this.selectedYeargraph4 = event.value;
        this.thirdGraph(this.isElcmTypeIcon3);
      }
      if (graphNo == 'graph5') {
        // this.selectedYear = event.value;
        console.log(this.selectedYear);
        this.selectedYeargraph5 = event.value;
        this.getEmployeeList();
        this.fourthGraph(this.isElcmTypeIcon4);
      }
      if (graphNo == 'all') {
        // this.selectedYear = event.value;
        console.log(this.selectedYear);
        this.selectedYear = event.value;
        this.selectedYeargraph1 = event.value;
        this.selectedYeargraph2 = event.value;
        this.selectedYeargraph3 = event.value;
        this.selectedYeargraph4 = event.value;
        this.selectedYeargraph5 = event.value;
        this.getElCMCountData();

        this.firstGraph(this.isElcmTypeIcon);
        this.hrField2Graph(this.isElcmTypeIconFieldHr);
        this.secondGraph(this.isElcmTypeIcon2);
        this.thirdGraph(this.isElcmTypeIcon3);
        this.fourthGraph(this.isElcmTypeIcon4);
      }

    } else {
      if (graphNo == 'graph1') {

        this.fromDate1 = event.value;
        // this.monthNumber=this.fromDate;
        console.log(this.monthNumber);

        this.firstGraph(this.isElcmTypeIcon);
      }
      if (graphNo == 'graph2') {
        // this.selectedYear = event.value;
        this.fromDate2 = event.value;

        this.hrField2Graph(this.isElcmTypeIconFieldHr);
      }
      if (graphNo == 'graph3') {
        // this.selectedYear = event.value;
        this.fromDate3 = event.value;

        this.secondGraph(this.isElcmTypeIcon2);
      }
      if (graphNo == 'graph4') {
        // this.selectedYear = event.value;
        this.fromDate4 = event.value;

        this.thirdGraph(this.isElcmTypeIcon3);
      }
      if (graphNo == 'graph5') {
        // this.selectedYear = event.value;
        this.fromDate5 = event.value;

        this.fourthGraph(this.isElcmTypeIcon4);
      }
      if (graphNo == 'all') {
        // this.selectedYear = event.value;
        this.fromDate1 = event.value;
        this.fromDate2 = event.value;
        this.fromDate3 = event.value;
        this.fromDate4 = event.value;
        this.fromDate5 = event.value;
        this.fromDate = event.value;
        this.monthNumber = event.value;
        this.firstGraph(this.isElcmTypeIcon);
        this.hrField2Graph(this.isElcmTypeIconFieldHr);
        this.secondGraph(this.isElcmTypeIcon2);
        this.thirdGraph(this.isElcmTypeIcon3);
        this.fourthGraph(this.isElcmTypeIcon4);
        this.getElCMCountData();

      }

    }

  }

  counterModule = [
    {
      moduleActiveIcon: '././assets/icon/activeEmp.svg',
      ModuleName: 'Employment Application',
      totalCount: 0,
      color: '#3067FA',
      background: '#D4DBEB',
      routerName: '/home/configrations/plants'
    },
    {
      moduleActiveIcon: '././assets/icon/goalSetting.svg',
      ModuleName: 'Emp. Application pending by HR',
      totalCount: 0,
      color: '#F3820E',
      background: '#FFE3C3',
      routerName: '/home/configrations/departments'
    },
    {
      moduleActiveIcon: '././assets/icon/goalReview.svg',
      ModuleName: 'Offers(accepted vs issued)',
      totalCount: 0,
      color: '#33B060',
      background: '#D5EBDD',
      routerName: '/home/configrations/shifts'
    },
    {
      moduleActiveIcon: '././assets/icon/goalReview.svg',
      ModuleName: 'Appoinment letters(issued)',
      totalCount: 0,
      color: '#33B060',
      background: '#D5EBDD',
      routerName: '/home/configrations/shifts'
    },

    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'On probation',
      totalCount: 0,
      color: '#E94848',
      background: '#F2DEDE',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/settingStatus.svg',
      ModuleName: 'Probation Extended',
      totalCount: 0,
      color: '#393186',
      background: '#DCDBEB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/reviewStatus.svg',
      ModuleName: 'confirmed',
      totalCount: 0,
      color: '#5C4CD3',
      background: '#D9D7EB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/aaproveStatus.svg',
      ModuleName: 'Exit(resignation)',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/aaproveStatus.svg',
      ModuleName: 'Exit(termination)',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configrations/incident-types'
    },
  ]

  counterModuleForHODAndManager = [

    {
      moduleActiveIcon: '././assets/icon/exitedEmp.svg',
      ModuleName: 'On probation',
      totalCount: 0,
      color: '#E94848',
      background: '#F2DEDE',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/settingStatus.svg',
      ModuleName: 'Probation Extended',
      totalCount: 0,
      color: '#393186',
      background: '#DCDBEB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/reviewStatus.svg',
      ModuleName: 'confirmed',
      totalCount: 0,
      color: '#5C4CD3',
      background: '#D9D7EB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/aaproveStatus.svg',
      ModuleName: 'Exit(resignation)',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configrations/incident-types'
    },
    {
      moduleActiveIcon: '././assets/icon/aaproveStatus.svg',
      ModuleName: 'Exit(termination)',
      totalCount: 0,
      color: '#982F2F',
      background: '#EECBCB',
      routerName: '/home/configrations/incident-types'
    },
  ]





  isElcmTypeIcon: any = 'bar';
  isElcmTypetable: boolean = false;
  switchelcmTypeGraph1(type: any) {
    this.isElcmTypeIcon = type;
    this.isElcmTypetable = false;

    setTimeout(() => {
      this.firstGraph(this.isElcmTypeIcon);

    }, 200);
  }


  switchElcmTypeTable1() {
    this.isElcmTypeIcon = 'table';
    this.isElcmTypetable = true;
  }
  selectedFromDated: any;
  selectedtoDated: any;
  downloadChartAsPDF(type: any): void {
    const currentDate = new Date();
    const todayDate = `${currentDate.getFullYear()}-${(currentDate.getMonth() + 1)
      .toString()
      .padStart(2, '0')}-${currentDate.getDate().toString().padStart(2, '0')}`;

    const formattedFromDate = this.selectedFromDated ? formatDate(this.selectedFromDated) : '';
    const formattedtoDate = this.selectedtoDated ? formatDate(this.selectedtoDated) : '';

    let idSelector = '';

    switch (type) {
      case 'Employment application filled vs issued':
        idSelector = this.isElcmTypeIcon === 'table' ? 'graph1-table-data' : 'chart-bar-application';
        break;
      case 'Filled by HR vs Filled by employee':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'graph2-table-data' : 'filed-hr-chart';
        break;
      case 'Offer lent sent vs Filled by HR':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'graph3-table-data' : 'offer-letter-chart';
        break;
      case 'Employee Joined vs offer lent sent':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'graph4-table-data' : 'third-elcm-chart';
        break;
      case 'Probation vs extension vs confirmation':
        idSelector = this.isElcmTypeIconFieldHr === 'table' ? 'graph5-table-data' : 'fourth-elcm-chart';
        break;
      default:
        // idSelector = this.selectGraphType === 'table' ? 'table-data-asset-allocatin-count' : 'bar-line-asset-allocatiom-chart';
        break;
    }

    let selectedYearForELCM;
    if (this.loggedInCompanyFiscalyear === "Jan_Dec") {
      selectedYearForELCM = this.selectedYear.split("-")[0];
    } else {
      selectedYearForELCM = this.selectedYear.split("-")[0];
    }
    if (idSelector === 'Probation vs extension vs confirmation') {
      selectedYearForELCM = ""; // Don't show the year
    }
    // Call the common function from the service
    this.PdfDownload.downloadPDF(
      idSelector, // chartId
      type, // Title
      selectedYearForELCM, // Year
      this.selectDepartmentForFourthGraph, // From Date
      formattedtoDate // To Date
    );
  }


  isElcmTypeIconFieldHr: string = 'bar';
  isElcmTypetableFieldHr: boolean = false;
  switchelcmTypeGraphFiledHr(type: any): void {
    this.isElcmTypeIconFieldHr = type;
    this.isElcmTypetableFieldHr = false;
    this.hrField2Graph(this.isElcmTypeIconFieldHr)
  }

  switchElcmTypeTableFieldHr(): void {
    this.isElcmTypetableFieldHr = !this.isElcmTypetableFieldHr;
    this.isElcmTypeIconFieldHr = 'table';
  }
  selectdepartMentForHrField(event: any) {

  }


  isElcmTypeIcon2: any = 'bar'; // Second Graph Type
  isElcmTypetable2: boolean = false; // Second Table View
  switchelcmTypeGraph2(type: any) {
    this.isElcmTypeIcon2 = type;
    this.isElcmTypetable2 = false;

    setTimeout(() => {
      this.secondGraph(this.isElcmTypeIcon2);

    }, 200);
  }

  // Function to switch between table and chart for the second graph
  switchElcmTypeTable2() {
    this.isElcmTypeIcon2 = 'table';
    this.isElcmTypetable2 = !this.isElcmTypetable2;

  }


  isElcmTypeIcon3: string = 'bar';
  isElcmTypetable3: boolean = false;
  selectDepartmentForofferAndAppoinment: any
  switchElcmTypeGraph3(type: string) {
    this.isElcmTypeIcon3 = type;
    this.isElcmTypetable3 = false;
    setTimeout(() => {
      this.thirdGraph(this.isElcmTypeIcon3);

    }, 200);
  }

  switchElcmTypeTable3() {
    this.isElcmTypeIcon3 = 'table';
    this.isElcmTypetable3 = !this.isElcmTypetable3;

  }

  selectDepartment3(event: any) {
    console.log('Selected Department:', event.value);
    this.selectDepartmentForofferAndAppoinment = event.value;
    this.thirdGraph(this.isElcmTypeIcon3)
  }

  isElcmTypeIcon4: string = 'bar'; // Default graph type
  isElcmTypetable4: boolean = false; // Toggle between table and chart
  departmentDataForFourthGraph: any[] = []; // Data for the graph/table
  switchElcmTypeGraph4(type: string) {
    this.isElcmTypeIcon4 = type;
    this.isElcmTypetable4 = false; // Hide table when switching graphs
    this.fourthGraph(this.isElcmTypeIcon4);
  }

  // Function to toggle table view
  switchElcmTypeTable4() {
    this.isElcmTypeIcon4 = 'table';
    this.isElcmTypetable4 = !this.isElcmTypetable4;
  }

  // Function to select department data
  selectDepartmentForFourthGraph: any
  selectDepartment4(event: any) {
    this.selectDepartmentForFourthGraph = event.value;
    console.log(this.selectDepartmentForFourthGraph);

    this.fourthGraph(this.isElcmTypeIcon4);
  }

  firstGraphTableData: any;
  firstGraph(graphtype: any) {
    console.log("Checking for chart container...");
    this.httpService.callGetService(`${this.config.elcmFirstGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate1}&year=${this.selectedYeargraph1}`)
      .subscribe((response: any) => {
        let data = response.data;
        this.firstGraphTableData = data;
        setTimeout(() => {

          const chartElement = document.getElementById('chart-bar-application');
          if (!chartElement) {
            console.error("Chart container with id 'chart-bar-quarterly' not found.");
            return;
          }



          let candidateData = [
            { platform: 'Application Send', data1: data.CandidateCount },
            { platform: 'Application Field', data2: data.FilledCandidateCount }
          ];

          createChartELCM('chart-bar-application', graphtype, candidateData);
        }, 200);  // Delay to allow the DOM to load
      })
  }
  selectDepartment: any;
  selectdepartMent(event: any) {
    console.log(event.value);
    this.selectDepartment = event.value;
    this.secondGraph(this.isElcmTypeIcon2);
  }

  hrFieldcandidateData: any = []
  hrField2Graph(graphtype: any) {
    let url;

    if (this.selectDepartment) {
      url = `${this.config.elcmHrFieldSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate2}&year=${this.selectedYeargraph2}&department=${this.selectDepartment}`
    } else {
      url = `${this.config.elcmHrFieldSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate2}&year=${this.selectedYeargraph2}`

    }

    // this.httpService.callGetService(`${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=2&year=${this.selectedYear}&department=null`)
    this.httpService.callGetService(url)
      .subscribe((response: any) => {

        this.hrFieldcandidateData = response.data;
        setTimeout(() => {

          const chartElement = document.getElementById('filed-hr-chart');
          if (!chartElement) {
            console.error("Chart container with id 'chart-bar-quarterly' not found.");
            return;
          }



          let candidateData = [
            { platform: 'Filled HR Count', data1: response.data.FilledHRCount },
            { platform: 'Filled Candidate Count', data2: response.data.FilledCandidateCount }
          ];

          createChartELCM('filed-hr-chart', graphtype, candidateData);
        }, 200);  // Delay to allow the DOM to load


      })
  }


  departmentData: any = []
  secondGraph(graphtype: any) {
    let url;

    if (this.selectDepartment) {
      url = `${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate3}&year=${this.selectedYeargraph3}&department=${this.selectDepartment}`
    } else {
      url = `${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate3}&year=${this.selectedYeargraph3}`

    }

    // this.httpService.callGetService(`${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=2&year=${this.selectedYear}&department=null`)
    this.httpService.callGetService(url)
      .subscribe((response: any) => {
        // Step 1: Convert object to array
        const transformedData = response.data.map((item: any) => ({
          xAxisValueData: item["Department Name"],
          seriesValueOneData: item["Send-Offer-Letter"],
          seriesValueTwoData: item["HR-Filled-Count"],
        }));

        this.departmentData = transformedData;
        transformedData.xAxisName = 'Department';
        transformedData.yAxisName = 'Department Count';
        transformedData.seriesLabelOne = 'Send Offer Letter Count';
        transformedData.seriesLabelTwo = 'HR Filled Count';

        if (graphtype == 'bar') {
          this.elcmBarChartActive(transformedData, 'offer-letter-chart', 'double');
        }
        if (graphtype == 'line') {
          this.elcmLineChartActive(transformedData, 'offer-letter-chart', 'double');
        }



      })
  }
  departmentDataForThirdGraphDD:any=[];
  departmentDataSecondDD:any=[];
allDropDown(){

  let  url2 = `${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate3}&year=${this.selectedYeargraph3}`
  let url3 = `${this.config.elcmThirdGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate4}&year=${this.selectedYeargraph4}`

  this.httpService.callGetService(url2)
      .subscribe((response: any) => {
        // Step 1: Convert object to array
        const transformedData = response.data.map((item: any) => ({
          xAxisValueData: item["Department Name"],
          
        }));
           
        this.departmentDataSecondDD = transformedData;
      })
   
  this.httpService.callGetService(url3)
  .subscribe((response: any) => {
    // Step 1: Convert object to array
    const transformedData = response.data.map((item: any) => ({
      xAxisValueData: item["Department Name"],
    }))
    
    this.departmentDataForThirdGraphDD = transformedData;
  })
}

  departmentDataForThirdGraph: any
  thirdGraph(graphtype: any) {
    let url;

    if (this.selectDepartmentForofferAndAppoinment) {
      url = `${this.config.elcmThirdGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate4}&year=${this.selectedYeargraph4}&department=${this.selectDepartmentForofferAndAppoinment}`
    } else {
      url = `${this.config.elcmThirdGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate4}&year=${this.selectedYeargraph4}`

    }

    // this.httpService.callGetService(`${this.config.elcmSecondGraph}?companyId=${this.loggedInUserCompanyID}&month=2&year=${this.selectedYear}&department=null`)
    this.httpService.callGetService(url)
      .subscribe((response: any) => {
        // Step 1: Convert object to array
        const transformedData = response.data.map((item: any) => ({
          xAxisValueData: item["Department Name"],
          seriesValueOneData: item["Send-Offer-Letter"],
          seriesValueTwoData: item["Approved-Appointment-Letter"],
        }));

        this.departmentDataForThirdGraph = transformedData;
        transformedData.xAxisName = 'Department';
        transformedData.yAxisName = 'Department Count';
        transformedData.seriesLabelOne = 'Send Offer Letter Count';
        transformedData.seriesLabelTwo = 'Approved Appointment Letter Count';

        if (graphtype == 'bar') {
          this.elcmBarChartActive(transformedData, 'third-elcm-chart', 'double');
        }
        if (graphtype == 'line') {
          this.elcmLineChartActive(transformedData, 'third-elcm-chart', 'double');
        }



      })
  }
  probationListData: any = [];
  //   }
  employeesDetails: any = []
  employeesProbationDetails: any = []
  currentemployeesDetails: any = []
  getEmployeeList() {

    // this.selectedYear
    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYeargraph5}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {
      this.employeesDetails = record.data.map((record: any) => {
        return {
          ...record,
          probationStatus: null,
          probationExtensionByDay: null,
          reasonForExtension: null,
          changesPostConfirmation: null,
          dateOfConfirmation: null
        }
      });
      this.currentemployeesDetails = this.employeesDetails;
      console.log(this.employeesDetails);
      this.fourthGraph(this.isElcmTypeIcon4)
    })
  }
  departmentDataForFourthGraphDD: any = []

  forDepartmentDropDown() {

    if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD')) {

      let url;
      let employeesDetails: any=[]

      url = `${this.config.elcmFourthGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate5}&year=${this.selectedYeargraph5}`
      this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYear}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((record: any) => {
        employeesDetails = record.data.map((record: any) => {
          return {
            ...record,
            probationStatus: null,
            probationExtensionByDay: null,
            reasonForExtension: null,
            changesPostConfirmation: null,
            dateOfConfirmation: null
          }
        });
        
      })

      this.httpService.callGetService(url)
        .subscribe((response: any) => {

          let commanData = [...employeesDetails, ...response.data];

          console.log("commanData",commanData);
          
          const transformedData: TransformedData = Object.values(
            commanData.reduce((acc: any, item: any) => {
              // Normalize department name from both sources
              const depatName = item.empDept || item["Department Name"];

              if (!acc[depatName]) {
                acc[depatName] = {
                  xAxisValueData: depatName,
                  seriesValueOneData: 0, // Employee count
                  seriesValueTwoData: 0, // Confirmation count
                  seriesValueThreeData: 0 // Extension count
                };
              }

              // Employee Details (from employeesDetails)
              if (item.empDept) {
                if (!item.probationDetailId) {
                  acc[depatName].seriesValueOneData += 1; // Count employees without probationDetailId
                }

              }

              // Response Data (from response.data)
              if (item["Department Name"]) {
                acc[depatName].seriesValueTwoData += item["Confirmation "] || 0; // Add confirmation count
                acc[depatName].seriesValueThreeData += item["Extension "] || 0; // Add extension count
              }

              return acc;
            }, {}) // <-- Corrected: Closing parenthesis added here
          );


          this.departmentDataForFourthGraphDD = transformedData;


        });


    }

  }

  fourthGraph(graphtype: any) {

    if ((this.loggedInUserRole == 'HR Admin' || this.loggedInUserRole == 'Super Admin' || this.loggedInUserRole == 'PHI Admin' || this.loggedInUserRole == 'MD')) {

      let url;

      if (this.selectDepartmentForFourthGraph) {
        url = `${this.config.elcmFourthGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate5}&year=${this.selectedYeargraph5}&department=${this.selectDepartmentForFourthGraph}`
      } else {
        url = `${this.config.elcmFourthGraph}?companyId=${this.loggedInUserCompanyID}&month=${this.fromDate5}&year=${this.selectedYeargraph5}`

      }

      this.httpService.callGetService(url)
        .subscribe((response: any) => {
         
          // if (this.selectDepartmentForFourthGraph) {
          //   console.log(this.currentemployeesDetails);
          //   this.employeesDetails = this.currentemployeesDetails.filter((elm: any) => {
          //     const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          //     return elm.empDept === this.selectDepartmentForFourthGraph && joiningMonth === this.fromDate5;
          // });
          
          //   console.log(response.data);


          // } else {

          //   this.employeesDetails = this.currentemployeesDetails.filter((elm: any) => {
          //     const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          //     return joiningMonth === this.fromDate5;
          // });
          

          // }

          if (this.selectDepartmentForFourthGraph) {
            console.log(this.currentemployeesDetails);
            this.employeesDetails = this.currentemployeesDetails.filter((elm: any) => {
              const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
              return elm.empDept === this.selectDepartmentForFourthGraph;
          });
          
            console.log(response.data);


          } else {

            this.employeesDetails = this.currentemployeesDetails;

          }
          let commanData = [...this.employeesDetails, ...response.data];
          const transformedData: TransformedData = Object.values(
            commanData.reduce((acc: any, item: any) => {
              // Normalize department name from both sources
              const depatName = item.empDept || item["Department Name"];

              if (!acc[depatName]) {
                acc[depatName] = {
                  xAxisValueData: depatName,
                  seriesValueOneData: 0, // Employee count
                  seriesValueTwoData: 0, // Confirmation count
                  seriesValueThreeData: 0 // Extension count
                };
              }

              // Employee Details (from employeesDetails)
              if (item.empDept) {
                if (!item.probationDetailId) {
                  acc[depatName].seriesValueOneData += 1; // Count employees without probationDetailId
                }

              }

              // Response Data (from response.data)
              if (item["Department Name"]) {
                acc[depatName].seriesValueTwoData += item["Confirmation "] || 0; // Add confirmation count
                acc[depatName].seriesValueThreeData += item["Extension "] || 0; // Add extension count
              }

              return acc;
            }, {}) // <-- Corrected: Closing parenthesis added here
          );


          this.departmentDataForFourthGraph = transformedData;
          transformedData.xAxisName = 'Department';
          transformedData.yAxisName = 'Department Count';
          transformedData.seriesLabelOne = 'Probation';
          transformedData.seriesLabelTwo = 'Confirmation';
          transformedData.seriesLabelThree = 'Extension';


          if (graphtype == 'bar') {
            this.elcmBarChartActive(transformedData, 'fourth-elcm-chart', 'three');
          }
          if (graphtype == 'line') {
            this.elcmLineChartActive(transformedData, 'fourth-elcm-chart', 'three');
          }



        })
    } else {
      this.hodAndManagerGraph(graphtype);
    }
  }
  currentemployeesProbationDetails: any = [];
  currentemployeesConfirmantionDetails: any = []

  EmployeeSummaryData: any = [];

  getEmployee() {

    const request = {
      "companyId": this.loggedInUserCompanyID,
      "userId": this.loggedInUserId
    };
    this.httpService.callPostService(this.config.getTeamOfManager, request).subscribe((data: any) => {
      this.EmployeeSummaryData = data.data;
      // this.hodAndManagerGraph()
    })
  }
  getProbationList() {
    this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)
      .subscribe((response: any) => {
        if (!response || !response?.data) return;

        this.currentemployeesConfirmantionDetails = response?.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
        console.log("cbvxcvxcv", this.currentemployeesConfirmantionDetails);

      })
  }

 dropdowndata:any=[]
 dd1:any=[];
 dd2:any=[];
 dd3:any=[];
 
  filterDataForConfirmatrion: any = []
  filterDataForExtention: any = []
  filterDataprobationListForHOD: any = []
  filterDataForConfirmatrionManager: any = []
  filterDataForExtentionManager: any = []
  filterDataprobationListForManager: any = []
  filterDataprobationListForManagerAndHod:any=[]
  filterDataForConfirmatrionManagerAndHod:any=[]
  filterDataForExtentionManagerAndHod:any=[]


  //  --------------------------------------------------According to month --------------------------------------------------------------

  // hodAndManagerGraph(graphType: any) {
  //   this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)

  //     .subscribe((response: any) => {
  //       this.filterDataForConfirmatrion = [];
  //       this.filterDataForConfirmatrionManager = []
  //       if (!response || !response?.data) return;

  //       // this.filterDataForConfirmatrion = response.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
  //       // this.filterDataForConfirmatrionManager = response.data.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode);
  //       this.filterDataForConfirmatrion = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return elm.hodCode === this.loggedInUserEmpCode && joiningMonth === this.fromDate5;
  //       });

  //       this.filterDataForConfirmatrionManager = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return elm.reportingManagerCode === this.loggedInUserEmpCode && joiningMonth === this.fromDate5;
  //       });

  //       this.filterDataForConfirmatrionManagerAndHod = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)||elm.reportingManagerCode==this.loggedInUserEmpCode)&& joiningMonth === this.fromDate5;
  //       });
  //       console.log(this.filterDataForConfirmatrionManager);

  //     })
  //   this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYeargraph5}`)
  //     .subscribe((response: any) => {
  //       this.filterDataForExtention = [];
  //       this.filterDataForExtentionManager = []
  //       if (!response || !response?.data) return;

  //       // this.filterDataForExtention = response.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension');
  //       // this.filterDataForExtentionManager = response.data.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension');
  //       this.filterDataForExtention = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return elm.hodCode === this.loggedInUserEmpCode &&
  //           elm.probationStatus == 'Extension' &&
  //           joiningMonth === this.fromDate5;
  //       });

  //       this.filterDataForExtentionManager = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return elm.reportingManagerCode === this.loggedInUserEmpCode &&
  //           elm.probationStatus == 'Extension' &&
  //           joiningMonth === this.fromDate5;
  //       });
  //       this.filterDataForExtentionManagerAndHod = response.data.filter((elm: any) => {
  //         const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //         return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)||elm.reportingManagerCode==this.loggedInUserEmpCode)&& joiningMonth === this.fromDate5;
  //       });

  //     })
  //   this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYeargraph5}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((response: any) => {
  //     this.filterDataprobationListForHOD = [];
  //     this.filterDataprobationListForManager = [];
  //     if (!response || !response?.data) return;
  //     let probationListForHOD = response?.data;
  //     // this.filterDataprobationListForHOD = probationListForHOD.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
  //     // this.filterDataprobationListForManager = probationListForHOD.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode);
  //     this.filterDataprobationListForHOD = probationListForHOD.filter((elm: any) => {
  //       const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //       return elm.hodCode === this.loggedInUserEmpCode && joiningMonth === this.fromDate5 && this.loggedInUserRole=='HOD';
  //     });

  //     this.filterDataprobationListForManager = probationListForHOD.filter((elm: any) => {
  //       const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //       return elm.reportingManagerCode === this.loggedInUserEmpCode && joiningMonth === this.fromDate5  && this.loggedInUserRole=='Manager';
  //     });
  //     this.filterDataprobationListForManagerAndHod = probationListForHOD.filter((elm: any) => {
  //       const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
  //       return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)||elm.reportingManagerCode==this.loggedInUserEmpCode)&& joiningMonth === this.fromDate5;
  //     });
  //     let CommanData: any = []


  //     if (this.loggedInUserRole == 'HOD' && this.httpService.confirmationProbationWhomSetup == 'HOD') {
  //       console.log("inside HOD");

  //       this.filterDataprobationListForHOD.forEach((elm: any) => {
  //         if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
  //           this.departmentDataForFourthGraph.push(elm.empDept);
  //         }
  //       });

  //       if (this.selectDepartmentForFourthGraph) {

  //         let selectedMonth = this.fromDate5;
  //         let filterDataprobationListForHOD = this.filterDataprobationListForHOD.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );

  //         let filterDataForConfirmatrion = this.filterDataForConfirmatrion.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );

  //         let filterDataForExtention = this.filterDataForExtention.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );
  //         CommanData = [
  //           ...filterDataprobationListForHOD,
  //           ...filterDataForConfirmatrion,
  //           ...filterDataForExtention
  //         ];
  //       } else {
  //         CommanData = [
  //           ...this.filterDataprobationListForHOD,
  //           ...this.filterDataForConfirmatrion,
  //           ...this.filterDataForExtention
  //         ];
  //       }

  //     }
  //     else if (this.filterDataprobationListForManagerAndHod.length>0 && this.confirmationProbationWhomSetup == 'LINE_MANAGER') {
  //       console.log("inside HOD and manager");

  //       this.filterDataprobationListForManagerAndHod.forEach((elm: any) => {
  //         if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
  //           this.departmentDataForFourthGraph.push(elm.empDept);
  //         }
  //       });

  //       if (this.selectDepartmentForFourthGraph) {

  //         let selectedMonth = this.fromDate5;
  //         let filterDataprobationListForManagerAndHod = this.filterDataprobationListForManagerAndHod.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );

  //         let filterDataForConfirmatrion = this.filterDataForConfirmatrionManagerAndHod.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );

  //         let filterDataForExtention = this.filterDataForExtentionManagerAndHod.filter(
  //           (elm: any) =>
  //             elm.empDept === this.selectDepartmentForFourthGraph &&
  //             new Date(elm.createdAt).getMonth() + 1 === selectedMonth
  //         );
  //         CommanData = [
  //           ...filterDataprobationListForManagerAndHod,
  //           ...filterDataForConfirmatrion,
  //           ...filterDataForExtention
  //         ];
  //       } else {
  //         CommanData = [
  //           ...this.filterDataprobationListForManagerAndHod,
  //           ...this.filterDataForConfirmatrionManagerAndHod,
  //           ...this.filterDataForExtention
  //         ];
  //       }

  //     } 
  //     else {
  //       console.log(this.filterDataprobationListForManager);

  //       this.filterDataprobationListForManager.forEach((elm: any) => {
  //         if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
  //           this.departmentDataForFourthGraph.push(elm.empDept);
  //         }
  //       });


  //       if (this.selectDepartmentForFourthGraph != undefined) {
  //         let filterDataprobationListForManager = this.filterDataprobationListForManager.filter(
  //           (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
  //         );
  //         const filteredEmployees = filterDataprobationListForManager.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });

  //         let filterDataForConfirmatrion = this.filterDataForConfirmatrionManager.filter(
  //           (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
  //         );
  //         const filterDataForConfirmatrionManager = filterDataForConfirmatrion.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });

  //         let filterDataForExtention = this.filterDataForExtention.filter(
  //           (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
  //         )
  //         const filterDataForExtentionManager = filterDataForExtention.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });

  //         CommanData = [...filteredEmployees, ...filterDataForConfirmatrionManager, ...filterDataForExtentionManager];
  //       } else {
  //         const filteredEmployees = this.filterDataprobationListForManager.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });
  //         const filterDataForConfirmatrionManager = this.filterDataForConfirmatrionManager.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         }); const filterDataForExtentionManager = this.filterDataForExtentionManager.filter((emp: any) => {
  //           const month = new Date(emp.createdAt).getMonth() + 1;
  //           return month === this.fromDate5;
  //         });

  //         CommanData = [...filteredEmployees, ...filterDataForConfirmatrionManager, ...filterDataForExtentionManager];
  //       }

  //     }




  //     const transformedData: TransformedData = Object.values(
  //       CommanData.reduce((acc: any, item: any) => {
  //         const assetName = item.empDept;
  //         if (!acc[assetName]) {
  //           acc[assetName] = {
  //             xAxisValueData: assetName,
  //             seriesValueOneData: 0,
  //             seriesValueTwoData: 0,
  //             seriesValueThreeData: 0
  //           };
  //         }
  //         if (!item.probationDetailId) {

  //           acc[assetName].seriesValueOneData += 1; // Increment employee count for the asset
  //         }
  //         if (item.probationStatus == "Confirmation") {
  //           acc[assetName].seriesValueTwoData += 1; // Count only confirmed employees
  //         }
  //         if (item.probationStatus == "Extension") {
  //           acc[assetName].seriesValueThreeData += 1; // Count only confirmed employees
  //         }

  //         return acc;
  //       }, {})
  //     );

  //     this.departmentDataForFourthGraphDD = transformedData;
  //     transformedData.xAxisName = 'Department';
  //     transformedData.yAxisName = 'Department Count';
  //     transformedData.seriesLabelOne = 'Probation';
  //     transformedData.seriesLabelTwo = 'Confirmation';
  //     transformedData.seriesLabelThree = 'Extension';
  //     console.log(transformedData)
  //     if (graphType == 'bar') {
  //       this.elcmBarChartActive(transformedData, 'fourth-elcm-chart', 'three');
  //     }
  //     if (graphType == 'line') {
  //       this.elcmLineChartActive(transformedData, 'fourth-elcm-chart', 'three');
  //     }
  //     this.manageeveryTabCount()
  //   })



  // }

  //  --------------------------------------------------According to month --------------------------------------------------------------


  hodAndManagerGraph(graphType: any) {
    this.httpService.callGetService(`${this.config.getProbationDetailsConfirmationEmployee}/${this.loggedInUserCompanyID}`)

      .subscribe((response: any) => {
        this.filterDataForConfirmatrion = [];
        this.filterDataForConfirmatrionManager = []
        if (!response || !response?.data) return;

        // this.filterDataForConfirmatrion = response.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
        // this.filterDataForConfirmatrionManager = response.data.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode);
        this.filterDataForConfirmatrion = response.data.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return elm.hodCode === this.loggedInUserEmpCode
        });

        this.filterDataForConfirmatrionManager = response.data.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return elm.reportingManagerCode === this.loggedInUserEmpCode 
        });

        this.filterDataForConfirmatrionManagerAndHod = response.data.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)
          ||elm.reportingManagerCode==this.loggedInUserEmpCode);
        });
     this.dd1=[... this.filterDataForConfirmatrion ,... this.filterDataForConfirmatrionManager,... this.filterDataForConfirmatrionManagerAndHod ]

      })
    this.httpService.callGetService(`${this.config.getProbationDetailsWithConfirmationDate}?companyId=${this.loggedInUserCompanyID}&year=${this.selectedYeargraph5}`)
      .subscribe((response: any) => {
        this.filterDataForExtention = [];
        this.filterDataForExtentionManager = []
        if (!response || !response?.data) return;

        // this.filterDataForExtention = response.data.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension');
        // this.filterDataForExtentionManager = response.data.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension');
        this.filterDataForExtention = response.data.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return elm.hodCode === this.loggedInUserEmpCode && elm.probationStatus == 'Extension'&& this.loggedInUserRole=='HOD' &&this.confirmationProbationWhomSetup == 'HOD';
        });


        this.filterDataForExtentionManager = response.data
        .filter((elm: any) => 
          elm.reportingManagerCode === this.loggedInUserEmpCode &&
          elm.probationStatus === 'Extension' &&
          this.loggedInUserRole === 'Manager'
        )
        .filter((employee: { empName: string; }, index: any, self: any[]) =>
          index === self.findIndex(
            (e) => e.empName?.trim().toLowerCase() === employee.empName?.trim().toLowerCase()
          )
        );
      


        this.filterDataForExtentionManagerAndHod = response.data.filter((elm: any) => {
          const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
          return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode &&this.confirmationProbationWhomSetup == 'LINE_MANAGER' && this.loggedInUserRole=='HOD'&& elm.probationStatus == 'Extension')||elm.reportingManagerCode==this.loggedInUserEmpCode && this.confirmationProbationWhomSetup == 'LINE_MANAGER'&& this.loggedInUserRole=='HOD' && elm.probationStatus == 'Extension');
        });
        console.log("--------------------------------------------------");
        
        console.log(this.filterDataForExtention);
        console.log(this.filterDataForExtentionManager);
        console.log(this.filterDataForExtentionManagerAndHod );
        this.dd2=[...this.filterDataForExtention,...this.filterDataForExtentionManager,...this.filterDataForExtentionManagerAndHod]
      })


    this.httpService.callGetService(`${this.config.getProbationDetails}?companyId=${this.loggedInUserCompanyID}&yearRange=${this.selectedYeargraph5}&fiscalType=${this.loggedInCompanyFiscalyear}`).subscribe((response: any) => {
      this.filterDataprobationListForHOD = [];
      this.filterDataprobationListForManager = [];
      if (!response || !response?.data) return;
      let probationListForHOD = response?.data;
      // this.filterDataprobationListForHOD = probationListForHOD.filter((elm: any) => elm.hodCode === this.loggedInUserEmpCode);
      // this.filterDataprobationListForManager = probationListForHOD.filter((elm: any) => elm.reportingManagerCode === this.loggedInUserEmpCode);
      this.filterDataprobationListForHOD = probationListForHOD.filter((elm: any) => {
        const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
        return elm.hodCode === this.loggedInUserEmpCode && this.loggedInUserRole=='HOD' &&this.confirmationProbationWhomSetup == 'HOD';
      });

      this.filterDataprobationListForManager = probationListForHOD.filter((elm: any) => {
        const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
        return elm.reportingManagerCode === this.loggedInUserEmpCode   && this.loggedInUserRole=='Manager';
      });
      this.filterDataprobationListForManagerAndHod = probationListForHOD.filter((elm: any) => {
        const joiningMonth = new Date(elm.createdAt).getMonth() + 1; // Extract month (1-based)
        return ((elm.reportingManagerCode === this.loggedInUserEmpCode && elm.hodCode === this.loggedInUserEmpCode)||elm.reportingManagerCode==this.loggedInUserEmpCode);
      });
      this.dd3=[...  this.filterDataprobationListForHOD ,...this.filterDataprobationListForManager,...this.filterDataprobationListForManagerAndHod]


      let CommanData: any = []


      if (this.loggedInUserRole == 'HOD' && this.httpService.confirmationProbationWhomSetup == 'HOD') {
        console.log("inside HOD");

        this.filterDataprobationListForHOD.forEach((elm: any) => {
          if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
            this.departmentDataForFourthGraph.push(elm.empDept);
          }
        });

        if (this.selectDepartmentForFourthGraph) {

          let selectedMonth = this.fromDate5;
          let filterDataprobationListForHOD = this.filterDataprobationListForHOD.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph
          );
          this.filterDataprobationListForHOD=filterDataprobationListForHOD;
          let filterDataForConfirmatrion = this.filterDataForConfirmatrion.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph 
          );
          this.filterDataForConfirmatrion=filterDataForConfirmatrion;
          let filterDataForExtention = this.filterDataForExtention.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph 
          );
          this.filterDataForExtention=filterDataForExtention;
          CommanData = [
            ...filterDataprobationListForHOD,
            ...filterDataForConfirmatrion,
            ...filterDataForExtention
          ];
        } else {
          CommanData = [
            ...this.filterDataprobationListForHOD,
            ...this.filterDataForConfirmatrion,
            ...this.filterDataForExtention
          ];
        }

      }
      else if (this.filterDataprobationListForManagerAndHod.length>0 && this.confirmationProbationWhomSetup == 'LINE_MANAGER' && this.loggedInUserRole!=='Manager') {
        // console.log("inside HOD and manager");

        this.filterDataprobationListForManagerAndHod.forEach((elm: any) => {
          if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
            this.departmentDataForFourthGraph.push(elm.empDept);
          }
        });

        if (this.selectDepartmentForFourthGraph) {

          let selectedMonth = this.fromDate5;
          let filterDataprobationListForManagerAndHod = this.filterDataprobationListForManagerAndHod.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph 
          );
          this.filterDataprobationListForManagerAndHod=filterDataprobationListForManagerAndHod;
          let filterDataForConfirmatrion = this.filterDataForConfirmatrionManagerAndHod.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph 
          );
          this.filterDataForConfirmatrionManagerAndHod=filterDataForConfirmatrion;
          let filterDataForExtention = this.filterDataForExtentionManagerAndHod.filter(
            (elm: any) =>
              elm.empDept === this.selectDepartmentForFourthGraph 
          );
          this.filterDataForExtentionManagerAndHod=filterDataForExtention;
          CommanData = [
            ...filterDataprobationListForManagerAndHod,
            ...filterDataForConfirmatrion,
            ...filterDataForExtention
          ];
        } else {
          CommanData = [
            ...this.filterDataprobationListForManagerAndHod,
            ...this.filterDataForConfirmatrionManagerAndHod,
            ...this.filterDataForExtention
          ];
        }

      } 
      else {
        console.log(this.filterDataprobationListForManager);
console.log("inside manager");

        this.filterDataprobationListForManager.forEach((elm: any) => {
          if (!this.departmentDataForFourthGraph.includes(elm.empDept)) {
            this.departmentDataForFourthGraph.push(elm.empDept);
          }
        });


        if (this.selectDepartmentForFourthGraph != undefined) {
          let filterDataprobationListForManager = this.filterDataprobationListForManager.filter(
            (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
          );
          this.filterDataprobationListForManager=filterDataprobationListForManager;
          const filteredEmployees = filterDataprobationListForManager;

          let filterDataForConfirmatrion = this.filterDataForConfirmatrionManager.filter(
            (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
          );
          this.filterDataForConfirmatrionManager=filterDataForConfirmatrion;
          const filterDataForConfirmatrionManager = filterDataForConfirmatrion;

          let filterDataForExtention = this.filterDataForExtentionManager.filter(
            (elm: any) => elm.empDept == this.selectDepartmentForFourthGraph
          )
          this.filterDataForExtentionManager=filterDataForExtention;
          const filterDataForExtentionManager = filterDataForExtention;

          CommanData = [...filteredEmployees, ...filterDataForConfirmatrionManager, ...filterDataForExtentionManager];
        } else {
          console.log("inside manager else");
          console.log(this.filterDataForExtentionManager);
          let uniqueEmployees = this.filterDataForExtentionManager.filter(
            (employee: { empName: string; }, index: any, self: any[]) =>
              index === self.findIndex(
                (e) => e.empName?.trim().toLowerCase() === employee.empName?.trim().toLowerCase()
              )
          );
          console.log(uniqueEmployees);
          
          
          
          const filteredEmployees = this.filterDataprobationListForManager;
          const filterDataForConfirmatrionManager = this.filterDataForConfirmatrionManager;
          const filterDataForExtentionManager = uniqueEmployees;
          CommanData = [...filteredEmployees, ...filterDataForConfirmatrionManager, ...filterDataForExtentionManager];
        }

      }



let combinedataforDD:any=[...this.dd1,...this.dd2,...this.dd3];
this.departmentDataForFourthGraphDD = []
console.log(combinedataforDD);

combinedataforDD.forEach((elm: any) => {
  if (elm?.empDept) { // Ensure empDept exists
    const deptName = elm.empDept.trim().toLowerCase(); // Normalize department name

    // Debugging: Log to verify department names
    console.log("Checking Department:", deptName);

    // Check if department already exists in the list
    if (!this.departmentDataForFourthGraphDD.some(
      (candidate: any) => candidate.xAxisValueData.trim().toLowerCase() === deptName
    )) {
      this.departmentDataForFourthGraphDD.push({
        id: deptName, // Store normalized name
        xAxisValueData: elm.empDept.trim(), // Keep original case for display
      });
    }
  }
});
console.log(this.departmentDataForFourthGraphDD);



      const transformedData: TransformedData = Object.values(
        CommanData.reduce((acc: any, item: any) => {
          const assetName = item.empDept;
          if (!acc[assetName]) {
            acc[assetName] = {
              xAxisValueData: assetName,
              seriesValueOneData: 0,
              seriesValueTwoData: 0,
              seriesValueThreeData: 0
            };
          }
          if (!item.probationDetailId) {

            acc[assetName].seriesValueOneData += 1; // Increment employee count for the asset
          }
          if (item.probationStatus == "Confirmation") {
            acc[assetName].seriesValueTwoData += 1; // Count only confirmed employees
          }
          if (item.probationStatus == "Extension") {
            acc[assetName].seriesValueThreeData += 1; // Count only confirmed employees
          }

          return acc;
        }, {})
      );

      // this.departmentDataForFourthGraphDD = transformedData;
      transformedData.xAxisName = 'Department';
      transformedData.yAxisName = 'Department Count';
      transformedData.seriesLabelOne = 'Probation';
      transformedData.seriesLabelTwo = 'Confirmation';
      transformedData.seriesLabelThree = 'Extension';
      console.log(transformedData)
      if (graphType == 'bar') {
        this.elcmBarChartActive(transformedData, 'fourth-elcm-chart', 'three');
      }
      if (graphType == 'line') {
        this.elcmLineChartActive(transformedData, 'fourth-elcm-chart', 'three');
      }
      this.manageeveryTabCount()
    })



  }

  manageeveryTabCount() {
    this.counterModule.forEach((module: any) => {
      switch (module.ModuleName) {
        case 'Employment Application':


          module.totalCount = `${this.employyeApplicationFromdata?.FilledCandidateCount ?? 0}/${this.employyeApplicationFromdata?.CandidateCount ?? 0}`;

          break;

        case 'Emp. Application pending by HR':
          module.totalCount = `${this.employyeApplicationFromdata?.CandidateCount}/${this.employyeApplicationFromdata?.FilledCandidateCount}` || '0/0';
          break;
        case 'Offers(accepted vs issued)':
          module.totalCount = `${this.employyeApplicationFromdata?.OfferLetterCount}/${this.employyeApplicationFromdata?.HRFilledCount}` || '0/0';
          break;
        case 'Appoinment letters(issued)':
          module.totalCount = `${this.employyeApplicationFromdata?.AppointmentLetterCount}/${this.employyeApplicationFromdata?.OfferLetterCount}` || '0/0';
          break;
        case 'On probation':
          module.totalCount = this.probationCount || '0';
          break;
        case 'Probation Extended':
          module.totalCount = this.employyeApplicationFromdata?.ExtensionCount || 0;;
          break;
        case 'confirmed':
          module.totalCount = this.employyeApplicationFromdata?.ConfirmationCount || 0;
          break;
        case 'Exit(resignation)':
          module.totalCount = 0;
          break;
        case 'Exit(termination)':
          module.totalCount = 0;
          break;
      }
    });
    this.counterModuleForHODAndManager.forEach((module: any) => {
      switch (module.ModuleName) {

        case 'On probation':
          module.totalCount =(this.filterDataprobationListForHOD.length || this.filterDataprobationListForManager.length ||this.filterDataprobationListForManagerAndHod.length)?? 0;
          break;
        case 'Probation Extended':
          module.totalCount = (this.filterDataForExtention.length || this.filterDataForExtentionManager.length ||this.filterDataForExtentionManagerAndHod.length)?? 0;;
          break;
          case 'confirmed':
            module.totalCount = 
              (this.filterDataForConfirmatrion.length || 
               this.filterDataForConfirmatrionManager.length || 
               this.filterDataForConfirmatrionManagerAndHod.length) ?? 0;
            break;
          
        case 'Exit(resignation)':
          module.totalCount = 0;
          break;
        case 'Exit(termination)':
          module.totalCount = 0;
          break;
      }
    });

  }

  // Usage for Line Chart
  elcmLineChartActive(data: any, idSelector: any, graphType: any): void {
    createChart(idSelector, 'line', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }

  // Usage for Bar Chart
  elcmBarChartActive(data: any, idSelector: any, graphType: any): void {
    createChart(idSelector, 'bar', graphType, data, {
      xAxisName: data.xAxisName,
      yAxisName: data.yAxisName,
    });
  }



 

}
interface TransformedDataItem {
  xAxisValueData: string;
  seriesValueOneData: number;
  seriesValueTwoData: number;
  seriesValueThreeData: number
}
interface TransformedData extends Array<TransformedDataItem> {
  xAxisName?: string;
  yAxisName?: string;
  seriesLabelOne?: string;
  seriesLabelTwo?: string;
  seriesLabelThree?: string
}
